import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

import { StringSmall } from '@/components/Typography/Typography';

const ErrorMessageBlock: React.FC = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      className="h-[20px] w-full flex items-center justify-center rounded-tl-[8px] rounded-tr-[8px] rounded-bl-0 rounded-br-0"
      style={{ background: '#FF585840' }}
      initial={{ y: '100%', opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: '100%', opacity: 0 }}
      transition={{
        ease: 'easeIn',
        duration: 0.2,
      }}
    >
      <StringSmall className="!text-[#FF5858] !text-[12px] !font-[400] !italic">
        {t('Task not completed. Try again!')}
      </StringSmall>
    </motion.div>
  );
};

export default ErrorMessageBlock;
